import { render } from "./PhotoTypeDialog.vue?vue&type=template&id=2e7afd9a"
import script from "./PhotoTypeDialog.vue?vue&type=script&lang=js"
export * from "./PhotoTypeDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__